import { render } from "./EditItemPriceModal.vue?vue&type=template&id=58e98f75"
import script from "./EditItemPriceModal.vue?vue&type=script&lang=js"
export * from "./EditItemPriceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__